<template lang="pug">
  canvas.Meteor(ref="canvas" :width="containWidth" :height="containHeight")
</template>

<script>
  import startImg from '@/assets/images/最右边的流星.png';
  export default {
    name: "Meteor",
    data() {
      return {
        containHeight: 600,
        containWidth: window.innerWidth,
        startHeight: 87,
        startWidth: 148,
        startList: [],
        startNumber: 5,
        ctx: null,
        startAngle: Math.atan(87 / 148),
        xVector: 0,
        yVector: 0,
        startImage: new Image(),
      };
    },
    created() {
      this.xVector = Math.cos(this.startAngle);
      this.yVector = Math.sin(this.startAngle);
    },
    methods: {
      initStartList() {
        for (let i = 0; i < this.startNumber; i++) {
          const start = this.makeStart();
          this.startList.push(start);
        }
      },
      makeStart() {
        if (Math.floor(Math.random * 100) % 2) {
          return {
            x: this.containWidth,
            y: this.makeStartY(),
            speed: this.makeStartSpeed(),
          };
        } else {
          return {
            x: this.makeStartX(),
            y: -this.startHeight,
            speed: this.makeStartSpeed(),
          };
        }
      },
      makeStartSpeed() {
        return Math.max(1, Math.random() * 10);
      },
      makeStartX() {
        return Math.random() * (
          this.containWidth + this.startWidth
        );
      },
      makeStartY() {
        return Math.random() * (
          this.containHeight + this.startHeight
        );
      },
      moveStarts() {
        for (let start of this.startList) {
          start.x -= start.speed * this.xVector;
          start.y += start.speed * this.yVector;
        }
      },
      drawStarts() {
        this.ctx.clearRect(0, 0, this.containWidth, this.containHeight);
        for (let index in this.startList) {
          const start = this.startList[index];
          if (start.x < -this.startWidth || start.y > this.containHeight) {
            this.startList.splice(index, 1, this.makeStart());
            continue;
          }
          this.ctx.drawImage(this.startImage, start.x, start.y);
        }
      },
      drawStart() {
        this.moveStarts();
        this.drawStarts();
        window.requestAnimationFrame(this.drawStart);
      },
    },
    mounted() {
      this.startImage.src = startImg;
      this.ctx = this.$refs.canvas.getContext('2d');
      this.initStartList();
      window.addEventListener('resize', () => this.containWidth = window.innerWidth);
      this.drawStart();
      this.$parent.$el.style.position = 'relative';
    },
  };
</script>

<style scoped lang="stylus">
  .Meteor {
    position absolute
    top 0
    left 0
  }
</style>
